import Vue from "vue";

Vue.filter("tofixed", (value, decimals) => value.toFixed(decimals));



// WEBPACK FOOTER //
// ./src/filters/tofixed.filter.js